import { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';

// any SEO related tags will be inside the <Helmet></Helmet> tag
// alongside the title.
// https://github.com/nfl/react-helmet

interface TAOOHelmetProps {
    title?: string;
    children?: ReactNode;
}

const BasePageTitle = 'TAOO |';

const TAOOHelmet = ({ title = '', children }: TAOOHelmetProps) => (
    <Helmet>
        <title>{`${BasePageTitle} ${title}`}</title>
        {children}
    </Helmet>
);

export default TAOOHelmet;
